<script setup lang="ts">
import {
  formatPrice,
} from "~/utils/formatters";

defineProps<{
  label: string;
  amount: number;
  originalAmount?: number | null;
}>();
</script>

<template>
  <div class="rounded-xl border border-amber-200 bg-amber-50/70 p-4 dark:border-amber-900/60 dark:bg-amber-950/20">
    <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <span class="font-semibold text-gray-900 dark:text-white">
        {{ label }}
      </span>
      <div class="flex items-baseline gap-2">
        <span
          v-if="originalAmount && originalAmount !== amount"
          class="text-sm font-semibold text-gray-500 line-through dark:text-gray-400"
        >
          {{ formatPrice(originalAmount) }}
        </span>
        <span class="text-2xl font-bold text-amber-700 dark:text-amber-300">
          {{ formatPrice(amount) }}
        </span>
      </div>
    </div>
  </div>
</template>
